export const goToClaimPage = (claim) => {
  const { claimCode, companyCode, year, perilCode, perilGroup } = claim;
  const wnd = window.open(
    `#/newclaims/${claimCode}?companyCode=${companyCode}&year=${year}&perilCode=${perilCode}&perilGroup=${perilGroup}`,
    "_blank",
  );

  wnd.onload = function () {
    wnd.document.title = `${claimCode}`;
  };
};
